import { listTimeSlots } from "src/components/Dashboard/Calendar/api";
import { setTimeSlots, setTimeSlotsLoading, setTimeSlotsError } from "./timeslotsSlice";

export const fetchTimeSlots = (forceRefresh = false, customEndDate = null) => async (dispatch, getState) => {
    const { lastFetch = 0 } = getState()?.timeslots || {};

    if (!forceRefresh && (Date.now() - lastFetch) < 24 * 60 * 60 * 1000) {
        return;
    }

    dispatch(setTimeSlotsLoading()); // signal fetch start so components can show a loader

    try {
        const today = new Date();
        const defaultEndDate = new Date(today);
        defaultEndDate.setDate(today.getDate() + 45);

        // If a schedule was added beyond 7 days, extend the fetch window to cover those timeslots
        const endDate = (customEndDate && new Date(customEndDate) > defaultEndDate)
            ? new Date(customEndDate)
            : defaultEndDate;

        const start = today.toISOString();
        const end = endDate.toISOString();
        const doctorId = sessionStorage.getItem("role-id");

        const data = { doctorId, start, end, };

        const res = await listTimeSlots(data);

        if (res) {
            dispatch(setTimeSlots(res));
        } else {
            dispatch(setTimeSlotsError("No time slots data returned."));
            console.error("No time slots data returned.");
        }
    } catch (error) {
        dispatch(setTimeSlotsError(error?.message || "Failed to fetch time slots."));
        console.error("Error fetching time slots:", error);
    }
}

// filter time slots by date
// Fixed: store key is "timeslots" (lowercase), not "timeSlots" — was always returning undefined
export const selectTimeSlotsForDate = (state, date) => {
    return state.timeslots.listTimeSlots.filter(slot => {
        const slotDate = new Date(slot.start).toDateString();
        return slotDate === date.toDateString();
    });
};
